import styled from 'styled-components/macro'

import * as React from 'react'

import jidloPodNosLogo from '../../../assets/jidloPodNosLogo.svg'

const StyledIcon = styled.img`
  display: block;
  width: 1em;
  height: 1em;
  object-fit: contain;
`

/**
 * Icon for Jidlo pod nos external partner,
 * intended to be rendered on its brand color background
 */
export const IconJidloPodNos = () => {
  return <StyledIcon src={jidloPodNosLogo} alt={`jpn logo`} />
}
